import { gql } from "@apollo/client";
import {DIMENSIONS_3D_FIELDS, IMAGE_FIELDS, MEDIA_FIELDS, MONEY_FIELDS, TRANSLATED_STRING_FIELDS} from "./common"

  export const ACCESSORY_CONFIGURATION_FIELDS = gql`
    fragment AccessoryConfigurationFields on AccessoryConfiguration {
        sizeType
        materialType
        platingType
      }`

      export const ACCESSORY_REFERENCE_FIELDS = gql`
      ${ACCESSORY_CONFIGURATION_FIELDS}
      fragment AccessoryReferenceFields on AccessoryReference {
        accessoryId
        accessoryModelId
        accessoryConfiguration { ...AccessoryConfigurationFields }
      }`

      export const ACCESSORY_WEIGHT_FIELDS = gql`
      ${ACCESSORY_CONFIGURATION_FIELDS}
      fragment AccessoryWeightFields on AccessoryWeight {
        configuration { ...AccessoryConfigurationFields }
        weightInGrams
      }`

      export const ACCESSORY_IMAGE_FIELDS = gql`
      ${ACCESSORY_CONFIGURATION_FIELDS}
      ${IMAGE_FIELDS}
      fragment AccessoryImageFields on AccessoryImage {
        configuration { ...AccessoryConfigurationFields }
        image { ...ImageFields }
      }`
      
      export const ACCESSORY_MODEL_FIELDS = gql`
      ${DIMENSIONS_3D_FIELDS}
      ${DIMENSIONS_3D_FIELDS}
      ${ACCESSORY_CONFIGURATION_FIELDS}
      ${ACCESSORY_WEIGHT_FIELDS}
      ${ACCESSORY_IMAGE_FIELDS}
      ${MEDIA_FIELDS}
      fragment AccessoryModelFields on AccessoryModel {
        id
        cadFile { ...MediaFields }
        sizeType
        dimensions { ...Dimensions3DFields }
        icon { ...MediaFields }
        availableConfigurations { ...AccessoryConfigurationFields }
        weights { ...AccessoryWeightFields }
        images { ...AccessoryImageFields }
        isPublishable
        hasDimensionsValid
        hasIconValid
        hasCadFileValid
        hasWeightsValid
        hasImagesValid
      }`

      export const ACCESSORY_FIELDS = gql`
      ${TRANSLATED_STRING_FIELDS}
      ${ACCESSORY_MODEL_FIELDS}
      fragment AccessoryFields on Accessory {
        id
        type
        title {...TranslatedStringFields}
        description {...TranslatedStringFields}
        models {...AccessoryModelFields}
        isPublishable
      }`

      export const PRICE_ACCESSORY_FIELDS = gql`
      ${MONEY_FIELDS}
      ${ACCESSORY_REFERENCE_FIELDS}
      fragment PriceAccessoryFields on PriceAccessory {
        accessoryReference {...AccessoryReferenceFields}
        price {...MoneyFields}
      }`

      export const ACCESSORY_ASSET_FIELDS = gql`
      ${ACCESSORY_FIELDS}
      fragment AccessoryAssetFields on AccessoryAsset {
        id
        ownerPartyId
        public
        accessory {...AccessoryFields }
        createdAt
        updatedAt
        isPublishable
      }`